// extracted by mini-css-extract-plugin
export var csatScore = "_m7-5";
export var header = "_m7-1";
export var panelWrapper = "_m7-2";
export var postPreview = "_m7-3";
export var rightContent = "_m7-0";
export var wrappingText = "_m7-4";